import { Component, OnInit } from '@angular/core';
import { RouterModule, Router, ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { TdDialogService } from '@covalent/core';
import { Route } from '@angular/router/src/config';
import { AuthenticationService } from '../../../../../shared/services/authentication.service';
import { ReceivingService } from '../../../../receiving/receiving.service';
import { ReceivingItem } from '../../../../receiving/receiving-item';
import { ITdDataTableColumn, TdDataTableComponent } from '@covalent/core/data-table/data-table.component';
import { TranslatePipe } from '../../../../../shared/pipes/translate.pipe';
import { ViewChild } from '@angular/core';
import { InventoryService } from '../../../../inventory/inventory.service';
import { Piece } from '../../../../inventory/piece';
import { Subscription } from 'rxjs/Subscription';
import { Receiving } from '../../../../receiving/receiving';
import { NewReceivedPieceComponent } from '../../../../../shared/dialogs/new-received-piece/new-received-piece.component';
import { PalletService } from 'app/shared/services/pallet.service';

@Component({
  selector: 'app-scan-pieces',
  templateUrl: './scan-pieces.component.html',
  styleUrls: ['./scan-pieces.component.scss'],
  providers: [PalletService]
})
export class ScanPiecesComponent implements OnInit {
  @ViewChild('dataTable') dataTable: TdDataTableComponent;

  _subscription: Subscription = new Subscription();

  multiMode: boolean = false;

  id: string;
  order_number: string = '';
  order_items: ReceivingItem[] = [];
  order: Receiving = new Receiving();

  piece_no: string;
  //piece_location: string;
  piece_length: number;
  piece_weight: number;

  pallet_name: string;

  piece_numbers: string;

  //locations: any[] = [];
  pallets: any[] = [];

  external_order: boolean = true;

  translatePipe: TranslatePipe = new TranslatePipe();

  transaction_status: string[] = [];
  confirmation_length: number = 0;

  _branch_id: number;

  columns: ITdDataTableColumn[] = [
    { name: 'check', label: '' },
    { name: 'piece_no', label: this.translatePipe.transform('piece_no', this._authService.getLanguage()) },
    { name: 'grade_code', label: this.translatePipe.transform('grade', this._authService.getLanguage()) },
    { name: 'pallet_name', label: this.translatePipe.transform('pallet', this._authService.getLanguage()) },
    { name: 'length', label: this.translatePipe.transform('length', this._authService.getLanguage()) },
    { name: 'weight', label: this.translatePipe.transform('weight_kg', this._authService.getLanguage()) },
  ];

  constructor(private router: Router,
    private _dialogService: TdDialogService,
    private location: Location,
    private route: ActivatedRoute,
    private _receivingService: ReceivingService,
    private _palletService: PalletService,
    private _inventoryService: InventoryService,
    public _authService: AuthenticationService
  ) { }

  ngOnInit() {
    this._subscription.add(
      this.route.params.subscribe(
        params => {
          this.id = params['recv_id'];
          this._subscription.add(
            this._receivingService.getReceivingItems(this.id + '').subscribe(
              response => {
                this.order_items = response;
                console.log(this.order_items);
              }
            )
          )

          this._subscription.add(
            this._receivingService.getReceiving(this.id).subscribe(
              response => {
                this.order = response;
              }
            )
          );
        }
      )
    )

    this.route.queryParams.subscribe(
      params => {
        this.order_number = params['order_number'];
        this._branch_id = params['branch_id'];
        this.external_order = (params['supplier_id'] != null && params['supplier_id'] != 'null');

        // Get pallets for the specific branch
        this.getPallets();
      }
    );
  }

  addAll() {
    this.order_items.forEach(item => {
      this.piece_numbers += item.piece_no + ' ';
    });
  }

  scanned() {
    if (this.multiMode) {
      this.scanMulti();
    } else {
      this.scanOne();
    }
  }

  scanMulti() {
    // If pallet is not in the list
    if (this.pallets.find((pallet) => { return pallet.name == this.pallet_name }) == null) {
      this._dialogService.openAlert({
        title: 'Invalid Pallet',
        message: 'The pallet that you scanned is not registered in your branch'
      });
      return;
    }

    console.log(this.piece_numbers.split(/\s+/));
    this.piece_numbers.split(/\s+/).forEach(
      p => {

        if (p.trim().length > 0) {
          let this_item: ReceivingItem = this.order_items.find((item) => { return item.piece_no == p });

          if (this_item == null) {
            this._dialogService.openAlert({
              title: 'Invalid Item',
              message: 'The item (' + p + ') that you scanned is not part of this receiving order'
            });
            return;
          } else {
            this_item.checked = true;
            this_item.pallet_name = this.pallet_name;
            // Commented out the piece_length and piece_weight cause they are not overwritable anymore.
            this_item.scanned_length = this_item.length; //this.piece_length;
            this_item.scanned_weight = this_item.weight; //this.piece_weight;
          }

          // Force change detection
          this.dataTable.refresh();
        }

      }
    );

    this.piece_numbers = '';
  }

  scanOne() {
    // If location is not in the list
    if (this.pallets.find((pallet) => { return pallet.name == this.pallet_name }) == null) {
      this._dialogService.openAlert({
        title: 'Invalid Pallet',
        message: 'The pallet that you scanned is not registered in your branch'
      });
      return;
    }

    let this_item: ReceivingItem = this.order_items.find((item) => { return item.piece_no == this.piece_no });

    if (this_item == null) {
      this._dialogService.openAlert({
        title: 'Invalid Item',
        message: 'The item that you scanned is not part of this receiving order'
      });
      return;
    } else {
      this_item.checked = true;
      this_item.pallet_name = this.pallet_name;
      // Commented out the piece_length and piece_weight cause they are not overwritable anymore.
      this_item.scanned_length = this_item.length; //this.piece_length;
      this_item.scanned_weight = this_item.weight; //this.piece_weight;
    }

    // Force change detection
    this.dataTable.refresh();

    //Then clear input fields
    this.piece_no = undefined;

  }

  receivedStatusText() {
    let totalPieces: number = (this.order_items || []).length;
    let preparedPieces: number = (this.order_items || []).filter(p => { return p.checked }).length;
    let totalMeters: number = (this.order_items || []).reduce((a, b) => { return a + b.length }, 0);
    let preparedMeters: number = (this.order_items || []).filter(p => { return p.checked }).reduce((a, b) => { return a + b.length }, 0);

    //console.log('total meters: ' + totalMeters);

    return preparedPieces + '/' + totalPieces + ' pieces scanned, ' + parseFloat(preparedMeters.toString()).toFixed(2) + '/' + parseFloat(totalMeters.toString()).toFixed(2) + ' meters scanned';
  }


  receivedStatusValue() {
    let totalPieces: number = (this.order_items || []).length;
    let preparedPieces: number = (this.order_items || []).filter(p => { return p.checked }).length;

    return (preparedPieces / totalPieces) * 100;
  }

  saveProgress() {
    this._receivingService.createReceivingItems(this.id, this.order_items).subscribe(
      response => {
        this._dialogService.openAlert(
          {
            title: 'Result',
            message: 'Progress saved!'
          }
        ).afterClosed().subscribe(
          result => {
            this.router.navigate(['/pda', 'receiving', 'scan']);
          });
      },
      error => {
        this._dialogService.openAlert(
          {
            title: 'Result',
            message: 'Could not save progress!'
          }
        )
      }
    );
  }

  confirmOrder() {
    let scanned = this.order_items.filter((i) => { return i['checked'] == true });
    let not_scanned = this.order_items.filter((i) => { return i['checked'] != true });

    if (not_scanned.length > 0) {
      this._dialogService.openConfirm({
        title: 'Warning!',
        message: 'Not all items in the order have been scanned. Do you want to continue?',
        acceptButton: 'Yes',
        cancelButton: 'No'
      }).afterClosed().subscribe(
        result => {
          if (result) {
            this.doConfirmOrder(scanned);
          }
        }
      );
    } else {
      this.doConfirmOrder(scanned);
    }
  }

  doConfirmOrder(final_items: ReceivingItem[]) {
    // We expect final_items.length + 1 confirmations
    this.confirmation_length = final_items.length + 1;

    // Set the receiving order to RECEIVED
    this._receivingService.getReceiving(this.id).subscribe(
      response => {
        if (response != null) {
          response.status = 'RECEIVED';
          response.actual_arrival_date = new Date().toISOString().substr(0, 10);

          this._receivingService.updateReceiving(response).subscribe(
            response => {
              this.reportStatus('Receiving marked as RECEIVED', true);
            },
            error => {
              this.reportStatus('Could not mark Receiving as RECEIVED', true);
            }
          );
        }
      }
    );

    // Set the scanned length and weight of the receiving pieces
    this._receivingService.createReceivingItems(this.id, this.order_items).subscribe(
      response => {

      }
    );

    // Add the pieces to the inventory
    final_items.forEach(
      (item) => {

        console.log(item);

        let piece: Piece = new Piece();

        piece.piece_number = item.piece_no;
        piece.color_id = item.color_id;
        piece.grade_code = item.grade_code;

        // Piece specs
        piece.lot_number = item.lot_no;
        piece.length = item.scanned_length;
        piece.weight = item.scanned_weight;

        piece.pallet_name = item.pallet_name;
        piece.pallet_id = item.pallet_id;

        piece.branch_id = this._branch_id;

        // Add it to the inventory!
        console.log("adding piece to inventory: " + piece.piece_number);

        this._inventoryService.addPiece(piece, this.external_order).subscribe(
          response => {
            if (response['status'] == 'SUCCESS') {
              this.reportStatus('Piece ' + response['piece_number'] + ' added to the inventory');
              console.log('Piece ' + response['piece_number'] + ' added to the inventory');
            } else {
              this.reportStatus('ERROR! Piece ' + response['piece_number'] + ' could not be added to the inventory');
              console.log('Piece ' + response['piece_number'] + ' could not be added to the inventory');
            }
          },
          error => {
            this.reportStatus('ERROR! Piece ' + error['piece_number'] + ' could not be added to the inventory');
            console.log('Piece ' + error['piece_number'] + ' could not be added to the inventory. ' + error);
          }
        );
      }
    )
  }

  addPiece() {
    this._dialogService.open(NewReceivedPieceComponent).afterClosed().subscribe(
      piece => {
        if (piece) {
          if (this.order_items.some(i => { return i.piece_no == piece.piece_no })) {
            this._dialogService.openAlert({ title: 'Invalid data', message: 'That piece number is already part of this receiving' })
          } else {
            this.order_items.push(piece);
            this.dataTable.refresh();
          }
        }
      }
    )
  }

  reportStatus(status: string, prepend?: boolean) {
    if (prepend) {
      this.transaction_status.unshift(status);
    } else {
      this.transaction_status.push(status);
    }

    if (this.transaction_status.length == this.confirmation_length) {
      let len = this.transaction_status.length;

      this._dialogService.openAlert(
        {
          title: 'Result',
          // if longer than 10 only show the first 10
          message: this.transaction_status.slice(0, 10).join(', ') +
            (len > 10 ? '... and ' + (len - 10) + ' more' : '')
        }
      ).afterClosed().subscribe(
        result => {
          this.router.navigate(['/pda', 'receiving', 'scan']);
        });
    }
  }

  goBack(): void {
    this.location.back();
  }

  suggestSpecs() {
    let entry: ReceivingItem;

    entry = this.order_items.find((item) => { return item.piece_no == this.piece_no });

    if (entry != null) {
      this.piece_length = entry.length;
      this.piece_weight = entry.weight;
    } else {
      this.piece_length = undefined;
      this.piece_weight = undefined;
    }
  }

  getPallets() {
    this._palletService.getPallets(this._branch_id).subscribe(
      response => {
        this.pallets = response;
      },
      error => {
        console.log("Error, unable to load pallets: " + error);
      }
    );
  }
}



// WEBPACK FOOTER //
// C:/Users/orion/Projects/simplicityEngine/valmust/valmustfe/src/app/agatextscreens/pda/receiving/scan/scan-pieces/scan-pieces.component.ts